/**
 * Email validation regex patterns
 */

// Standard email regex pattern
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// More permissive email regex for international domains
export const EMAIL_INTERNATIONAL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Email validation constraints
export const EMAIL_MAX_LENGTH = 254;
export const EMAIL_LOCAL_MAX_LENGTH = 64;

/**
 * Validates email format
 */
export function validateEmail(
    email: string
): {
    isValid: boolean;
    errors: string[];
} {
    const errors: string[] = [];
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
        errors.push('Email is required');
        return { isValid: false, errors };
    }

    if (trimmedEmail.length > EMAIL_MAX_LENGTH) {
        errors.push(`Email cannot exceed ${EMAIL_MAX_LENGTH} characters`);
    }

    const [localPart] = trimmedEmail.split('@');
    if (localPart && localPart.length > EMAIL_LOCAL_MAX_LENGTH) {
        errors.push(`Email local part cannot exceed ${EMAIL_LOCAL_MAX_LENGTH} characters`);
    }

    if (!EMAIL_REGEX.test(trimmedEmail)) {
        errors.push('Please enter a valid email address');
    }

    return {
        isValid: errors.length === 0,
        errors
    };
}

/**
 * Normalizes email format
 */
export function normalizeEmail(email: string): string {
    return email.trim().toLowerCase();
}
